import React, { Fragment, useEffect, useState } from "react";
import {
  Dropdown,
  Container,
  Form,
  Nav,
  Navbar,
  InputGroup,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { branchmaster } from "../../services/login";

function Header() {
  const navigate = useNavigate();
  const headerToggleButton = () => {
    let body = document.querySelector("body");
    let innerWidth = window.innerWidth;
    if (body !== !body) {
      if (innerWidth >= 992) {
        document.querySelector("body")?.classList.toggle("main-sidebar-hide");
        document.querySelector("body")?.classList.remove("main-sidebar-show");
      } else if (document.body.classList.contains("horizontalmenu")) {
        document.querySelector("body")?.classList.toggle("main-navbar-show");
        document.querySelector("body")?.classList.remove("main-sidebar-show");
        document.querySelector("body")?.classList.remove("main-sidebar-hide");
      } else {
        document.querySelector("body")?.classList.toggle("main-sidebar-show");
        document.querySelector("body")?.classList.remove("main-sidebar-hide");
      }
    }
  };

  function errorhandle(ev) {
    ev.target.src = require("../../assets/images/logo/logo.png");
    ev.target.onerror = null;
  }

  function Swicherbutton() {
    document.querySelector(".demo_changer").classList.toggle("active");
    document.querySelector(".demo_changer").style.right = "0px";
  }
  const Darkmode = () => {
    document.querySelector("body").classList.toggle("dark-theme");
  };
  const [blist, setBList] = useState([]);

  const [branch, setBranch] = useState("");
  const [elogo, setElogo] = useState("");
  const location = useLocation();

  useEffect(() => {
    branchmaster().then((res) => {
      if (res.status === true) {
        const userBranches = localStorage.getItem("branches")
                            .split(",") 
                            .map(Number);
        const filteredBranches = res.data.filter(branch => userBranches.includes(branch.id));
        setBList(filteredBranches);
        const bdata = res.data.find((item) => item.id == localStorage.getItem("branch"));
        if (bdata) {
          setBranch(bdata.branch_name);
        }
      }
    })
  }, [location]);
  return (
    <Fragment>
      <Navbar
        expand="lg"
        className="main-header side-header sticky"
      // style={{ marginBottom: "-64px" }}
      >
        <Container fluid className="main-container container-fluid">
          <div className="main-header-left">
            <Link
              className="main-header-menu-icon"
              onClick={() => headerToggleButton()}
            >
              <span></span>
            </Link>
            <div className="hor-logo">
              <a className="main-logo">
                <img
                  src={require("../../assets/images/logo/service_logo.png")}
                  className="header-brand-img desktop-logo"
                  alt="logo"
                  onError={errorhandle}
                />
              </a>
            </div>
          </div>
          <div>


            <h2 className="schoolheading tx-24 mg-b-0" style={{textTransform: "uppercase"}}>
              {/* Global Financial Services -  */}
              {branch} Branch
            </h2>
          </div>
          {localStorage.getItem("Roleid") === "5" && (
            <div className="main-header-center">
              {" "}
              <h4 className="tx-28 text-dark text-center">
                Welcome {localStorage.getItem("User")}
              </h4>
            </div>
          )}

          <div className="main-header-right">
            <Navbar.Toggle
              aria-controls="navbarSupportedContent-4"
              className="navresponsive-toggler"
            >
              <i className="fe fe-more-vertical header-icons navbar-toggler-icon"></i>
            </Navbar.Toggle>

            <div className="navbar navbar-expand-lg nav nav-item navbar-nav-right responsive-navbar navbar-dark">
              <Navbar.Collapse className="collapse navbar-collapse">
                <div className="d-flex order-lg-2 align-items-center ms-auto">
                  {/* <Dropdown className="header-search">
                    <Dropdown.Toggle variant="default" className="px-0">
                      <i className="fe fe-search header-icons fs-18 px-2 lh-5"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="p-2">
                      <InputGroup>
                        <Form.Control
                          type="search"
                          className="rounded-0"
                          placeholder="Search for anything..."
                        />
                        <InputGroup.Text className="btn search-btn">
                          <i className="fe fe-search"></i>
                        </InputGroup.Text>
                      </InputGroup>
                    </Dropdown.Menu>
                  </Dropdown> */}

                  <Dropdown className=" main-header-notification">
                    {/* <Dropdown.Toggle
                      className="nav-link icon"
                      variant="default"
                    >
                      <i className="fe fe-bell header-icons"></i>
                      {ncnt != 0 && (
                        <span className="badge bg-danger nav-link-badge">
                          {ncnt}
                        </span>
                      )}
                    </Dropdown.Toggle> */}
                    {/* <Dropdown.Menu style={{ margin: "0px" }}>
                      {ncnt != 0 && (
                        <>
                          <div className="header-navheading">
                            <p className="main-notification-text">
                              You have {ncnt} unread notification
                            </p>
                          </div>
                          <div className="main-notification-list">
                            {nlist.map((item) => {
                              return (
                                <div className="media new" key={item.id} onClick={() => navigate("/notifications/notificationlist")}>
                                  <div className="main-img-user online">
                                    <img
                                      alt="avatar"
                                      src={require("../../assets/images/icons/notification.png")}
                                    />
                                  </div>
                                  <div className="media-body">
                                    <p>{item.title}</p>
                                    <span>
                                      {moment(item.created_at).fromNow()}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      )}
                      {ncnt == 0 && (
                        <div className="header-navheading">
                          <p className="main-notification-text">
                            You have no recent notification
                          </p>
                        </div>
                      )}

                      <div className="dropdown-footer">
                        <Link to="/notifications/notificationlist">
                          View All Notifications
                        </Link>
                      </div>
                    </Dropdown.Menu>*/}
                  </Dropdown>

                  <Dropdown className="main-profile-menu">
                    <Dropdown.Toggle className="d-flex p-0" variant="default">
                      <span className="main-img-user mx-1">
                        <img
                          alt="avatar"
                          src={require("../../assets/images/logo/user.jpg")}
                        />
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ margin: "0px" }}>
                      <div className="header-navheading">
                        <h6 className="main-notification-title">
                          {localStorage.getItem("User")}
                        </h6>
                        {/* {localStorage.getItem("Role") !== "1" && (
                          <a className="main-notification-text">
                            {localStorage.getItem("Role")}
                          </a>
                        )} */}
                      </div>
                      {blist.map((item) => {
                        return (
                          <Dropdown.Item onClick={() => {
                            if (String(item.id) === localStorage.getItem('branch')) return;
                            localStorage.setItem('branch', item.id);
                            // Pages read the branch from localStorage on mount, so reload to fetch the new branch's data
                            window.location.reload();
                          }} key={item.id}>
                            <i className="fas fa-code-branch"></i> {item.branch_name} Branch
                          </Dropdown.Item>
                        )
                      })}
                      {/* <Dropdown.Item className="border-top">
                        <i className="fe fe-user"></i> My Profile
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <i className="fe fe-settings"></i> Account Settings
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <i className="fe fe-headphones"></i>Support
                      </Dropdown.Item> */}
                      <Dropdown.Item
                        onClick={() => {
                          localStorage.clear();
                          navigate("/login");
                        }}
                      >
                        <i className="fe fe-power"></i> Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  {/* <Dropdown className="dropdown d-flex main-header-theme">
                    <Nav.Link
                      className="nav-link icon layout-setting"
                      onClick={() => Darkmode()}
                    >
                      <span className="dark-layout">
                        <i className="fe fe-sun header-icons"></i>
                      </span>
                      <span className="light-layout">
                        <i className="fe fe-moon header-icons"></i>
                      </span>
                    </Nav.Link>
                  </Dropdown> */}
                </div>
              </Navbar.Collapse>

              {/* <div className="d-flex header-setting-icon demo-icon fa-spin">
                <Nav.Link className="nav-link icon" onClick={Swicherbutton}>
                  <i className="fe fe-settings settings-icon "></i>
                </Nav.Link>
              </div> */}
            </div>
          </div>
        </Container>
      </Navbar>
    </Fragment>
  );
}

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
